import React from 'react';
import { Section } from '@finect/tabular-components/Section';
import { Video } from '@finect/tabular-components/Videos';
import { VideoInner } from './partials';
export const ProductVideo = _ref => {
  let {
    product,
    bottomMargin = false
  } = _ref;
  const {
    entity
  } = product;
  if (!product || !product.entity || !product.entity.video) {
    return null;
  }
  return React.createElement(Section, {
    bottomMargin: bottomMargin
  }, React.createElement(VideoInner, null, React.createElement(Video, {
    video: entity.video,
    thumbnailSize: "max"
  })));
};